'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Logan = require('../util/logan');

var LogManager = function () {
    function LogManager(cfgManager) {
        _classCallCheck(this, LogManager);

        this.cfgManager = cfgManager;
    }

    _createClass(LogManager, [{
        key: 'addLog',
        value: function addLog(log) {
            if (typeof log !== 'string') throw 'addLog只接受string类型的日志';
            Logan.log('[Log]: ' + log, {
                noType: true
            });
        }
    }]);

    return LogManager;
}();

module.exports = LogManager;


//////////////////
// WEBPACK FOOTER
// ./~/@dp/owl/lib/log/manager.js
// module id = 248
// module chunks = 0